export default __webpack_public_path__ + "static/Rhyme3-ba9c3935fab5342c8a508b00f10b5cac.mp3";